import React, { useEffect, useState } from "react";

import { OutlinkInteractionOutro } from "@/service/Model";
import { Icons, Svg } from "@/styles";
import { isAndroidDevice, isIosDevice, isMobilePhone } from "@/utils/getters";

import { OutroPropsExtented } from "../index";
import {
  Counter,
  ImageBox,
  ImageLinkBox,
  ImageLinkLoading,
  OutlinkWrapper,
  TimeoutOverlay,
  TimerIconWrapper,
} from "./styles";

interface OutlinkProps extends OutroPropsExtented {
  outro: OutlinkInteractionOutro;
}

let interval = 0;
const TIMEOUT = 10;

const Outlink: React.FC<OutlinkProps> = (
  props: OutlinkProps
): React.JSX.Element => {
  const {
    background,
    mobileBackground,
    autoForwardTimerEnabled,
    autoForwardTimerSeconds,
  } = props.outro;

  const initialSeconds = autoForwardTimerSeconds ?? TIMEOUT;
  const [loaded, setLoaded] = useState(false);
  const [seconds, setSeconds] = useState(initialSeconds);

  const url = isMobilePhone()
    ? `${mobileBackground ?? background}?width=${window.innerWidth - 10}`
    : background;

  useEffect(() => {
    loadImage();
    if (!autoForwardTimerEnabled) {
      return;
    }
    interval = window.setInterval(() => {
      setSeconds((prevSeconds: number) => prevSeconds - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      window.clearInterval(interval);
      window.open(getLink(), window.self !== window.top ? "_parent" : "_self");
      props.onClose();
    }
  }, [seconds]);

  const getLink = (): string => {
    const { outlinkUrl, iosOutlinkUrl, androidOutlinkUrl } = props.outro;
    if (isAndroidDevice() && androidOutlinkUrl) {
      return androidOutlinkUrl;
    }
    if (isIosDevice() && iosOutlinkUrl) {
      return iosOutlinkUrl;
    }
    return outlinkUrl;
  };

  const loadImage = (): void => {
    if (!url) {
      return;
    }
    const img = new Image();
    img.onload = () => setLoaded(true);
    img.onerror = () => setLoaded(false);
    img.src = url;
  };

  const stopTimer = (): void => {
    // prevent that the outlink is opened twice automatically
    window.clearInterval(interval);
    props.onClose();
  };

  return (
    <OutlinkWrapper data-qa={"outlink"}>
      {autoForwardTimerEnabled && (
        <TimeoutOverlay>
          <TimerIconWrapper>
            <Svg contents={Icons.Clock} height={24} width={24} />
          </TimerIconWrapper>
          {"Weiterleitung in"}
          <Counter>{seconds}</Counter>
          {"Sekunden"}
        </TimeoutOverlay>
      )}
      <ImageLinkBox onClick={stopTimer} href={getLink()} target="_blank">
        {loaded ? <ImageBox src={url} /> : <ImageLinkLoading />}
      </ImageLinkBox>
    </OutlinkWrapper>
  );
};

export default Outlink;
